// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Accordion, Blockquote, ButtonCell, Button, Cell, Section, IconButton, Modal, Input, Image, Navigation, Spinner, Skeleton } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as HomeIcon } from "../assets/home.svg";
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as DeleteIcon } from "../assets/delete.svg";
import { ReactComponent as TelegramNotice } from '../assets/social/tg_notice.svg';
import { ReactComponent as PromptsIcon } from "../assets/prompts.svg";

const tg = window.Telegram.WebApp;

const SourcesPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [streams, setStreams] = useState(selectedGroup.streams);
    const [sources, setSources] = useState(stream.sources);
    const [formattedSources, setFormattedSources] = useState([]);
    const [sourceRef, setSourceRef] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [isInputDisabled, setIsInputDisabled] = useState(false);
    const [addLoading, setAddLoading] = useState(false);

    const [showLoader, setShowLoader] = useState(false);

    const skeleton_favicon = "https://gmpapp.ru/images/no_favicon.svg"

    const isTelegramLink = (name) => {
        // Проверяем, начинается ли строка с одного из указанных префиксов
        return (
            name.startsWith('https://t.me/') ||
            name.startsWith('http://t.me/') ||
            name.startsWith('t.me/') ||
            name.startsWith('@')
        );
    };

    const delete_source = async (name) => {
        const url = 'https://api.gmpapp.ru/delete_source';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, source: name }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                setFormattedSources(prevSources =>
                    prevSources.filter(source => source.name !== name)
                );
                
                // Оптимистичное обновление
                const newSources = sources.filter(s => s !== name);
                setSources(newSources);
                stream.sources = newSources;
                
                setAccordionStates(formattedSources.map(() => false))
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const saveSources = async () => {
        const url = 'https://api.gmpapp.ru/save_sources';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, source: sourceRef }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                
                // Оптимистичное обновление
                if (!sources.includes(sourceRef)) {
                    const newSources = [...sources, sourceRef];
                    setSources(newSources);
                    stream.sources = newSources;
                }
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const addSource = async () => {
        setIsAdding(true);
        setAddLoading(true);
        setIsInputDisabled(true);
        tg.BackButton.hide();
        setShowLoader(true);
        saveSources();
        try {
            const response = await fetch(`https://api.gmpapp.ru/get_title?url=${sourceRef}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            console.log(`${data.title}\n${data.favicon}\n${data.desc}`);
            setFormattedSources((prevSources) => [
                ...prevSources,
                {
                    title: data.title,
                    name: sourceRef,
                    favicon: data.favicon,
                    desc: data.desc
                }
            ]);
        } catch (error) {
            tg.BackButton.show();
            setShowLoader(false);
            console.error('Error fetching data:', error); // Покажем полное сообщение об ошибке
        }
        finally {
            tg.BackButton.show();
            setShowLoader(false);
            setAddLoading(false);
            setIsAdding(false);
            setSourceRef('');
            setIsInputDisabled(false);
        }
    };


    const [accordionStates, setAccordionStates] = useState(
        formattedSources.map(() => false) // Изначально все аккордеоны закрыты
    );

    const handleAccordionChange = (index) => {
        setAccordionStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index]; // Инвертируем состояние
            return newStates;
        });
    };

    const handleKeyPress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            addSource(); // Вызов функции addSource
        }
    };

    useEffect(() => {
        const dividers = document.querySelectorAll('.sectionSourceDone.tgui-8af0d10d5540c6cc');
        if (dividers.length > 0) {
            console.log('found dividers')
            const lastDivider = dividers[dividers.length - 1];
            lastDivider.style.display = isAdding ? 'block' : 'none';
        }
    }, [isAdding]); // Данный эффект зависит от isAdding

    // Эффект для загрузки заголовков при изменении источников
    useEffect(() => {
        const fetchTitles = async () => {
            setIsLoading(true);
            setIsAdding(true);

            try {
                // Создаем базовую структуру с id и name
                const initialSources = sources.map((source, index) => ({
                    id: index,
                    name: source,
                    title: source // временное значение
                }));

                // Параллельно запрашиваем заголовки для всех источников
                const updatedSources = await Promise.all(
                    initialSources.map(async (source) => {
                        try {
                            const response = await fetch(
                                `https://api.gmpapp.ru/get_title?url=${encodeURIComponent(source.name)}`
                            );
                            const data = await response.json();

                            return {
                                ...source,
                                title: data.title || source.name, // сохраняем оригинал при ошибке
                                favicon: data.favicon || null,
                                desc: data.desc || null
                            };
                        } catch (error) {
                            return {
                                ...source,
                                title: source.name, // возвращаем оригинал при ошибке
                                favicon: null,
                                desc: null
                            };
                        }
                    })
                );

                setFormattedSources(updatedSources);
            } catch (error) {
                console.error('Error fetching titles:', error);
            } finally {
                setIsLoading(false);
                setIsAdding(false);
            }
        };

        if (sources && sources.length > 0) {
            fetchTitles();
        }
    }, []); // Зависимость от sources

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'sources') {
            tg.BackButton.show();
            console.log(streams);
            console.log(sources);
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    const deleteStream = (id) => {
        // Обновляем массив streams, фильтруя стримы по id
        console.log(id)
        const updatedStreams = streams.filter(stream => stream.id !== id);

        // Устанавливаем обновленный массив в состояние
        setStreams(updatedStreams);
        console.log(updatedStreams);
    };

    const renameStream = (id, newName) => {
        const renamedStreams = streams.map(stream => {
            if (stream.id === id) {
                return { ...stream, name: newName };
            }
            return stream;
        });

        setStreams(renamedStreams);
        console.log(renamedStreams)
    };

    // useEffect(() => {
    //     console.log('stream edited')
    //     const saveStreams = async () => {
    //         const url = 'https://api.gmpapp.ru/save_streams';
    //         const streamsToSend = streams.slice(1);

    //         try {
    //             const response = await fetch(url, {
    //                 method: 'POST',
    //                 headers: { 'Content-Type': 'application/json' },
    //                 body: JSON.stringify({ streams: streamsToSend, group_id: selectedGroup.id }),
    //             });

    //             if (!response.ok) {
    //                 // Здесь можно обрабатывать неуспешные коды ответов
    //                 console.error('Error:', response.status, response.statusText);
    //             } else {
    //                 // Если ответ успешен, можно сделать что-то с данными
    //                 const data = await response.json();
    //                 console.log('Success:', data);
    //             }
    //         } catch (error) {
    //             console.error('Error streams sending', error);
    //         }
    //     };

    //     saveStreams();
    // }, [streams]);

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                {isLoading ?
                    <Section className='sectionChannelSources' header="Управление источниками" footer="Здесь вы можете добавить источник, откуда сервис будет брать новости или посты. Источником может быть любой новостной сайт, Telegram-канал или группа/паблик VK">
                        {sources.map((source, index) => (
                            <Accordion className="sourceItem">
                                <Accordion.Summary
                                    before={
                                        <Skeleton visible>
                                            <Image style={{ borderRadius: "20px" }} className='sourceFavicon' size={28} src={skeleton_favicon}></Image>
                                        </Skeleton>
                                    }
                                    subtitle={<Skeleton visible>Skeleton</Skeleton>}
                                >
                                    <Skeleton visible>Skeleton title lorem ipsum</Skeleton>
                                </Accordion.Summary>
                            </Accordion>
                        ))}
                        {/* <Input after={<IconButton className="addSource" size="m"><AddIcon /></IconButton>} status="focused" header="Input" placeholder="Введите источник..." /> */}
                    </Section>
                    :
                    <Section className='sectionChannelSources sectionSourceDone' header="Управление источниками" footer="Здесь вы можете добавить источник, откуда сервис будет брать новости или посты. Источником может быть любой новостной сайт, Telegram-канал или группа/паблик VK">
                        {formattedSources.map((source, index) => (
                            <Accordion className="sourceItem" expanded={accordionStates[index]} onChange={() => handleAccordionChange(index)}>
                                <Accordion.Summary before={<Image className='sourceFavicon' size={28} src={source.favicon}>{isTelegramLink(source.name) && <TelegramNotice className='socialBadge' />}</Image>} subtitle={source.name}>{source.title}</Accordion.Summary>
                                <Accordion.Content>
                                    {source.desc && <div style={{ padding: '10px 20px 20px' }} dangerouslySetInnerHTML={{ __html: source.desc }} />}
                                    <div className='fullURL'>
                                        <Blockquote type="text">
                                            Ссылка на источник:<br />
                                            <a
                                                href={
                                                    source.name.startsWith('http://') || source.name.startsWith('https://')
                                                        ? source.name
                                                        : source.name.startsWith('@')
                                                            ? `https://t.me/${source.name.slice(1)}`
                                                            : `http://${source.name}`
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {source.name} <br /><br />
                                            </a>
                                        </Blockquote>
                                    </div>
                                    <div className='deleteSourceSection' style={{ padding: '10px 20px 20px' }}>
                                        <Button stretched onClick={() => delete_source(source.name)} className='deleteSource' mode="bezeled" before={<DeleteIcon />}>Удалить источник</Button>
                                    </div>
                                </Accordion.Content>
                            </Accordion>
                        ))}
                        {isAdding ?
                            <Accordion className="sourceItemAdding">
                                <Accordion.Summary
                                    before={
                                        <Skeleton visible>
                                            <Image style={{ borderRadius: "20px" }} className='sourceFavicon' size={28} src={skeleton_favicon}></Image>
                                        </Skeleton>
                                    }
                                    subtitle={<Skeleton visible>Skeleton</Skeleton>}
                                >
                                    <Skeleton visible>Skeleton title lorem ipsum</Skeleton>
                                </Accordion.Summary>
                            </Accordion> : null}
                        <Input after={<IconButton disabled={!sourceRef} onClick={addSource} className="addSource" size="m">{addLoading ? <Spinner size="s" /> : <AddIcon />}</IconButton>} value={sourceRef} disabled={isInputDisabled} onKeyPress={handleKeyPress} onChange={e => setSourceRef(e.target.value)} status="focused" header="Input" placeholder="Введите источник..." />
                    </Section>
                }
                <Section className='sectionChannelSources' header='Дополнительно'>
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('sourceslib'); }} className='settingsItem' before={<PromptsIcon className='SettingsItemIcon' />} after={<Navigation />}>Подборки источников</Cell>
                </Section>
                {showLoader && (
                    <Spinner className="saveLoader" size="m" />
                )}
            </AppRoot>
        </div>
    );
};

export default SourcesPage;